import { Component, OnInit, Input } from "@angular/core";
import { EvsUserService } from "../../../../../../common/services/EvsUser.service";
import { EvsStoreService } from "../../../../../../common/services/EvsStore.service";
import { EvsAddressService } from "../../../../../../common/services/EvsAddress.service";
import { EvsProductService } from "../../../../../../common/services/EvsProduct.service";
import { ToastrService } from "ngx-toastr";
import { ConfirmationService, Message } from "primeng/primeng";
import { BatchService } from "../../../../qrcode/batchstamp/batch.service";
import { ImageService } from "../../../../../imageService";
declare var $: any;
import * as _ from 'lodash';

@Component({
  selector: "assign",
  templateUrl: "./assign.component.html",
  styleUrls: ["./assign.component.css"],
  providers: [
    EvsUserService,
    EvsStoreService,
    EvsAddressService,
    ConfirmationService,
    EvsProductService,
    ImageService
  ]
})
export class AssignComponent implements OnInit {
  constructor(
    private productService: EvsProductService,
    private toastr: ToastrService,
    private batchService: BatchService,
    private imageService: ImageService
  ) { }
  @Input("user") user: any;
  no_product = "assets/images/no_product.png";
  no_image = "assets/images/no-image.png";
  cities: any = [];
  page_size: number = 10;
  batchCurrentPage: number = 1;
  productCurrentPage: number = 1;
  batchOffset: number = 0;
  productOffset: number = 0;
  totalBatch: number = 0;
  totalPageBatch: number = 0;
  batches: any = [];
  products: any = [];
  batch: any = {};
  listBatch: any = [];
  batchFocus: boolean = false;

  totalProduct: number = 0;
  totalPageProduct: number = 0;
  product : any = {};
  listProduct : any = [];
  productFocus : boolean = false;

  ngOnInit() {
    this.loadBatch();
    this.loadProduct();
  }

  loadBatch(request: any = {}, sort: any = {}) {
    this.batches = [];
    request.offset =
      this.page_size * (this.batchCurrentPage <= 0 ? 0 : this.batchCurrentPage - 1);
    request.limit = this.page_size;
    request.show_parent_child = true;

    this.batchService
      .getBatchesAssign(this.user.id, request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200) {
            this.batches = _.map(res.data.batches, e => {
              let start = e.id_start.toString();
              let end = e.id_end.toString();
              while (start.length < 6) {
                start = '0' + start;
              }
              while (end.length < 6) {
                end = '0' + end;
              }
              e.serial_end = e.prefix + '-' + end;
              e.serial_start = e.prefix + '-' + start;
              return e;
            })
            this.totalBatch = res.data.total.count;
            console.log(res.data);
            var pageString = (this.totalBatch / this.page_size).toString();
            console.log(pageString);
            var pageSplit = pageString.split(".");
            var last: any;
            var totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPageBatch = totalpage;
            console.log(this.totalPageBatch)
          } else {
            this.batches = [];
          }
        },
        err => {
          this.batches = [];
        }
      );
  }

  getBatch() {
    if (this.batch.name) {
      let data_get: any = {
        limit: 100,
        offset: 0,
        show_parent_child: true,
        name: this.batch.name
      };
      this.batchService.getBatchesList(data_get).subscribe(res => {
        if (!res.error) {
          this.listBatch = res.data.batches;
        }
      });
    }
  }

  assignBatch() {
    console.log('batch', this.batch);
    if (this.batch && this.batch.id) {
      this.batchService.assignBatch(this.batch.id, this.user.id).toPromise().then(res => {
        this.toastr.success('Phân quyền quản lý thành công');
        console.log('bada', this.batch);
        if(this.batch.parent_id) {
          this.batchService.assignBatch(this.batch.parent_id, this.user.id).toPromise().then(res => {
            this.loadBatch();
            this.batch = {};
          })
        }else {
          this.loadBatch();
        this.batch = {};
        }
      })
        .catch((err: any) => {
          let mess = "Lô tem đã được phân quyền cho nhân viên";
          this.toastr.warning(mess, "Thông báo:", {
            timeOut: 4000,
            positionClass: "toast-top-right"
          });
          console.log("createBatchStamp:catch", err);
        });
    }
  }

  focusoutBatch() {
    setTimeout(() => {
      this.batchFocus = false;
    }, 200);
  }

  deleteAssignBatch(id) {
    this.batchService.deleteAssignBatch(id, this.user.id).subscribe(res => {
      if (!res.error) {
        this.toastr.success('Xoá quyền quản lý thành công');
        this.loadBatch();
      } else {
        this.toastr.error('Xoá quyền quản lý thất bại');
      }
    })
  }

  setPageBatch(page: number) {
    if (page <= this.totalPageBatch) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.batchCurrentPage) {
        this.batchCurrentPage = page;
        this.loadBatch();
      }
    } else {
      page = this.totalPageBatch;
      $("#inputPageBatch").val(page);
      this.toastr.warning("Số trang tối đa hiện tại là " + page, "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
      if (page <= this.totalPageBatch) {
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.batchCurrentPage) {
          this.batchCurrentPage = page;
          this.loadBatch();
        }
      }
    }
  }

  goPage2Batch(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPageBatch(toPage);
    }
  }

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  loadProduct(request: any = {}, sort: any = {}) {
    this.products = [];
    request.offset =
      this.page_size * (this.productCurrentPage <= 0 ? 0 : this.productCurrentPage - 1);
    request.limit = this.page_size;

    this.productService
      .getAssignProduct(this.user.id, request)
      .toPromise()
      .then(
        res => {
          if (res.status == 200) {
            this.products = _.map(res.data.products, e => {
              e.image = this.imageService.readSrcImage(
                e.image,
                "thumb_medium"
              );
              return e;
            });
            console.log(res.data);
            this.totalProduct = res.data.count.count;
            var pageString = (this.totalProduct / this.page_size).toString();
            var pageSplit = pageString.split(".");
            var last: any;
            var totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPageProduct = totalpage;
          } else {
            this.products = [];
          }
        },
        err => {
          this.products = [];
        }
      );
  }

  getProduct() {
    if (this.product.name) {
      let data_get: any = {
        limit: 1000,
        offset: 0,
        name: this.product.name
      };
      this.productService.all(data_get).subscribe(res => {
        if (!res.error) {
          this.listProduct = res.data.products;
        }
      });
    }
  }


  setPageProduct(page: number) {
    if (page <= this.totalPageProduct) {
      if (page < 1) {
        page = 1;
      }
      if (page != this.productCurrentPage) {
        this.productCurrentPage = page;
        this.loadProduct();
      }
    } else {
      page = this.totalPageProduct;
      $("#inputPageProduct").val(page);
      this.toastr.warning("Số trang tối đa hiện tại là " + page, "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right"
      });
      if (page <= this.totalPageProduct) {
        //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
        if (page < 1) {
          page = 1;
        }
        if (page != this.productCurrentPage) {
          this.productCurrentPage = page;
          this.loadProduct();
        }
      }
    }
  }

  goPage2Product(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPageProduct(toPage);
    }
  }

  focusoutProduct() {
    setTimeout(() => {
      this.productFocus = false;
    }, 200);
  }


  assignProduct() {
    console.log('product', this.product);
    if (this.product && this.product.id) {
      this.productService.assignProduct(this.product.id, this.user.id).toPromise().then(res => {
        this.toastr.success('Phân quyền quản lý thành công');
        this.loadProduct();
        this.product = {};
      })
        .catch((err: any) => {
          let mess = "Sản phẩm đã được phân quyền cho nhân viên";
          this.toastr.warning(mess, "Thông báo:", {
            timeOut: 4000,
            positionClass: "toast-top-right"
          });
          console.log("createBatchStamp:catch", err);
        });
    }
  }

  deleteAssignProduct(id) {
    this.productService.deleteAssignProduct(id, this.user.id).subscribe(res => {
      if (!res.error) {
        this.toastr.success('Xoá quyền quản lý thành công');
        this.loadProduct();
      } else {
        this.toastr.error('Xoá quyền quản lý thất bại');
      }
    })
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/modal-manager/assign/assign.component.ts